<template>
  <SACModal
    modalClass="plan-builder-info-modal"
    :cardClass="`${infoModalView}-builder`"
    :show="showInfoModal"
    :close="close"
  >
    <template
      v-if="infoModalView === 'comfort-credit'"
      #content
    >
      <ComfortCreditInfo
        :close="close"
      />
    </template>
    <template
      v-else-if="infoModalView === 'system-inspection'"
      #content
    >
      <SystemInspectionInfo
        :close="close"
      />
    </template>
    <template
      v-else-if="infoModalView === 'plan-benefit'"
      #content
    >
      <PlanBenefitInfo
        :plan="plan"
        :close="close"
      />
    </template>
    <template
      v-else-if="infoModalView === 'smart-maintenance'"
      #content
    >
      <SmartMaintenanceInfo
        :close="close"
      />
    </template>
  </SACModal>
</template>

<script>
import SACModal from '@shared/components/sac/SACModal.vue';
import ComfortCreditInfo from './infoModal/ComfortCreditInfo.vue';
import SystemInspectionInfo from './infoModal/SystemInspectionInfo.vue';
import PlanBenefitInfo from './infoModal/PlanBenefitInfo.vue';
import SmartMaintenanceInfo from './infoModal/SmartMaintenanceInfo.vue';

export default {
  name: 'InfoModal',
  components: {
    SACModal,
    ComfortCreditInfo,
    SystemInspectionInfo,
    PlanBenefitInfo,
    SmartMaintenanceInfo,
  },
  props: {
    infoModalView: String,
    showInfoModal: Boolean,
    close: Function,
    plan: Object,
  },
};
</script>

<style lang="scss">

.plan-builder-info-modal {
  .comfort-credit-builder {
    width: 456px;
  }
  .system-inspection-builder {
    width: 456px;
  }
  .plan-benefit-builder {
    width: 456px;
  }
  .smart-maintenance-builder {
    width: 456px;
    max-height: 90vh;
    .ac-body-container {
      overflow-y: auto;
    }
  }
  .ac-card-content {
    display: flex;
    flex-direction: column;
    animation: fadeIn 0.5s ease;
    position: relative;
    max-height: 90vh;
    .ac-body-container {
      flex: 1;
      padding: 31px 12px 26px 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .ac-logo {
        width: 120px;
        margin-bottom: 10px;
        object-fit: contain;
      }
      .ac-header {
        font-size: 1.25rem;
        color: $NAVY100;
        font-weight: 500;
        margin-bottom: 32px;
      }
      .ac-plan-container {
        display: flex;
        align-items: center;
        flex-direction: column;
        border: 1px solid $N5;
        border-radius: 6px;
        padding: 13px 23px;
        width: 90%;
        &:not(:first-child) {
          margin-top: 12px;
        }
        .ac-plan-header {
          display: flex;
          align-items: center;
          font-size: 1rem;
          font-weight: 400;
          color: $NAVY100;
          img {
            margin-right: 11px;
          }
        }
        .ac-plan-body-header {
          font-size: 0.75rem;
          color: $NAVY100;
          font-weight: 600;
        }
        .ac-plan-body {
          font-size: 0.6875rem;
          color: $N90;
          text-align: center;
        }
      }
      .ac-button {
        padding: 2px 9px;
        font-size: 0.625rem;
        color: $N90;
        background-color: #CAD7FF;
        border-radius: 3px;
        margin-top: 48px;
      }
    }
  }
}
</style>
